import React, { useState, useEffect } from 'react';
import { useTranslation } from 'react-i18next';
import { FaFacebook, FaInstagram, FaLinkedin, FaTiktok, FaWhatsapp } from 'react-icons/fa';
import axios from 'axios';

// URL لـ Google Maps (يمكنك تحديثه لاحقاً برابط حقيقي)
  const googleMapsUrl = "https://www.google.com/maps/place/31%C2%B030'19.6%22N+35%C2%B002'10.5%22E/@31.505444,35.0375485,18z/data=!3m1!4b1!4m4!3m3!8m2!3d31.505444!4d35.036261?entry=ttu&g_ep=EgoyMDI1MDkyNC4wIKXMDSoASAFQAw%3D%3D";

const API_URL_PUBLIC = "https://one-stop.ps/api/footer-settings"; // استخدم رابط API عام هنا

const Footer = () => {
  const { t, i18n } = useTranslation();
  const isRTL = i18n.language === 'ar';
  const textAlignmentClass = isRTL ? 'text-right' : 'text-left';

  const [footerData, setFooterData] = useState({
    description: t('footer_description'), // قيمة احتياطية
    email: 'info@one-stop.ps',
    phone: '+972569900416',
    address: t('full_address') || 'Palestine - Hebron - Dura - Banks Street',
    social: { facebook: '#', instagram: '#', linkedin: '#', tiktok: '#', whatsapp: '#' }
  });

  const colors = {
    turquoise: '#218A7A', // تركواز IT 158-1
    darkBlue: '#003366', // أزرق غامق IT 160-3
    yellow: '#FFDD33', // أصفر IT 58-5
  };

  // جلب إعدادات التذييل من الـ API
  useEffect(() => {
    const fetchFooterSettings = async () => {
      try {
        const response = await axios.get(API_URL_PUBLIC);
        const settings = response.data;

        // تحديد الوصف والعنوان بناءً على اللغة الحالية
        const descriptionKey = isRTL ? 'footer_description_ar' : 'footer_description_en';
        const addressKey = isRTL ? 'contact_address_ar' : 'contact_address_en';
        
        setFooterData({
          description: settings[descriptionKey] || t('footer_description_fallback'),
          email: settings.contact_email || 'info@one-stop.ps',
          phone: settings.contact_phone || '+972569900416',
          address: settings[addressKey] || t('full_address_fallback'),
          social: {
            facebook: settings.social_facebook || '#',
            instagram: settings.social_instagram || '#',
            linkedin: settings.social_linkedin || '#',
            tiktok: settings.social_tiktok || '#',
            whatsapp: settings.social_whatsapp || '#',
          }
        });
      } catch (error) {
        console.error('Error fetching footer data, using default/i18n:', error);
        // في حال الفشل، نعتمد على قيم i18n الافتراضية
      }
    };
    fetchFooterSettings();
    // إعادة الجلب عند تغيير اللغة
  }, [i18n.language, isRTL, t]);


  return (
    <footer className="bg-gray-800 dark:bg-gray-950 text-white py-12 md:py-16">
      <div className="container mx-auto px-4 sm:px-6 lg:px-8">
        <div className={`grid grid-cols-1 md:grid-cols-3 lg:grid-cols-5 gap-8 md:gap-12 text-sm ${textAlignmentClass}`}>
          
          {/* Company Info (Logo + About) */}
          <div className="md:col-span-1 lg:col-span-2">
            <h3 className={`text-2xl font-extrabold mb-4 tracking-wider text-left`} style={{ color: colors.turquoise }} dir="ltr"> 
              One Stop Company
            </h3>
            {/* استخدام البيانات القادمة من API */}
            <p className="text-gray-200 dark:text-gray-300 leading-relaxed max-w-md"> 
              {footerData.description} 
            </p>
          </div>

          {/* Quick Links (لا تغيير) */}
          {/* ... */}
          <div className="mt-4 md:mt-0">
            <h4 className="text-lg font-bold mb-4" style={{ color: colors.yellow }}> 
              {t('quick_links')}
            </h4>
            <ul className={`space-y-3 ${textAlignmentClass}`}>
              <li><a href="#about" className="text-white dark:text-gray-200 hover:underline transition-colors duration-200" onMouseEnter={(e) => e.currentTarget.style.color = colors.turquoise} onMouseLeave={(e) => e.currentTarget.style.color = 'white'}>{t('about_us')}</a></li>
              <li><a href="#services" className="text-white dark:text-gray-200 hover:underline transition-colors duration-200" onMouseEnter={(e) => e.currentTarget.style.color = colors.turquoise} onMouseLeave={(e) => e.currentTarget.style.color = 'white'}>{t('services')}</a></li>
              <li><a href="#blogs" className="text-white dark:text-gray-200 hover:underline transition-colors duration-200" onMouseEnter={(e) => e.currentTarget.style.color = colors.turquoise} onMouseLeave={(e) => e.currentTarget.style.color = 'white'}>{t('blogs_news_title')}</a></li>
              <li><a href="#certificates" className="text-white dark:text-gray-200 hover:underline transition-colors duration-200" onMouseEnter={(e) => e.currentTarget.style.color = colors.turquoise} onMouseLeave={(e) => e.currentTarget.style.color = 'white'}>{t('certificates_title')}</a></li>
              <li><a href="#team" className="text-white dark:text-gray-200 hover:underline transition-colors duration-200" onMouseEnter={(e) => e.currentTarget.style.color = colors.turquoise} onMouseLeave={(e) => e.currentTarget.style.color = 'white'}>{t('team_title')}</a></li>
              <li><a href="#contact" className="text-white dark:text-gray-200 hover:underline transition-colors duration-200" onMouseEnter={(e) => e.currentTarget.style.color = colors.turquoise} onMouseLeave={(e) => e.currentTarget.style.color = 'white'}>{t('contact_us_title')}</a></li>
            </ul>
          </div>
          
          {/* Contact Info - تحديث لاستخدام البيانات */}
          <div className="mt-4 md:mt-0">
            <h4 className="text-lg font-bold mb-4" style={{ color: colors.yellow }}>
              {t('contact_us')}
            </h4>
            <ul className={`space-y-3 ${textAlignmentClass}`}>
              {/* Email */}
              <li className="flex items-center" style={{ flexDirection: isRTL ? 'row-reverse' : 'row' }}>
                <a 
                  href={`mailto:${footerData.email}`} 
                  className="text-white dark:text-gray-200 hover:underline transition-colors duration-200"
                  onMouseEnter={(e) => e.currentTarget.style.color = colors.turquoise} 
                  onMouseLeave={(e) => e.currentTarget.style.color = 'white'}
                >
                  {footerData.email}
                </a>
                <svg xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 24 24" strokeWidth="1.5" stroke="currentColor" className={`w-5 h-5 ${isRTL ? 'mr-2' : 'ml-2'}`}>
                  <path strokeLinecap="round" strokeLinejoin="round" d="M21.75 6.75v10.5a2.25 2.25 0 0 1-2.25 2.25H5.25A2.25 2.25 0 0 1 3 17.25V6.75m18 0A2.25 2.25 0 0 0 19.5 4.5h-15a2.25 2.25 0 0 0-2.25 2.25m18 0v.562m-18-.562c0-1.105.895-2 2-2h12.556L18 7.375 21.75 6.75Z" />
                </svg>
              </li>
              {/* Phone */}
              <li className="flex items-center" style={{ flexDirection: isRTL ? 'row-reverse' : 'row' }}>
                <a 
                  href={`tel:${footerData.phone.replace(/[^0-9+]/g, '')}`} 
                  className="text-white dark:text-gray-200 hover:underline transition-colors duration-200 whitespace-nowrap"
                  onMouseEnter={(e) => e.currentTarget.style.color = colors.turquoise} 
                  onMouseLeave={(e) => e.currentTarget.style.color = 'white'}
                >
                  {footerData.phone}
                </a>
                <svg xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 24 24" strokeWidth="1.5" stroke="currentColor" className={`w-5 h-5 ${isRTL ? 'mr-2' : 'ml-2'}`}>
                  <path strokeLinecap="round" strokeLinejoin="round" d="M2.25 6.75c0 8.284 6.716 15 15 15h2.25a2.25 2.25 0 0 0 2.25-2.25v-1.372c0-.516-.351-.966-.852-1.106l-1.412-.363a1.125 1.125 0 0 1-.823-.307l-2.541-2.541a1.125 1.125 0 0 1-.307-.823v-1.412a1.125 1.125 0 0 1 1.106-.852l.363-1.412A2.25 2.25 0 0 0 18.75 8.25V6H9.75a2.25 2.25 0 0 0-2.25 2.25v2.25c0 .354.124.693.351.972l2.541 2.541c.28.28.618.404.972.404h.54c.354 0 .693-.124.972-.351l2.541-2.541c.227-.28.351-.618.351-.972v-.54a1.125 1.125 0 0 0-1.106-.852L9 8.25a2.25 2.25 0 0 0-2.25 2.25V15" />
                </svg>
              </li>
              {/* Location Text */}
              <li>
                <p className="text-white dark:text-gray-200">
                  {footerData.address}
                </p>
              </li>
              {/* Location Map Button (لا تغيير) */}
              <li>
                <a
                  href={googleMapsUrl}
                  target="_blank"
                  rel="noopener noreferrer"
                  className="inline-flex items-center gap-2 px-4 py-2 rounded-md transition-colors duration-300 shadow-md"
                  style={{ backgroundColor: colors.darkBlue, color: colors.yellow, borderColor: colors.yellow }}
                  onMouseEnter={(e) => {
                    e.currentTarget.style.backgroundColor = colors.yellow;
                    e.currentTarget.style.color = colors.darkBlue;
                  }}
                  onMouseLeave={(e) => {
                    e.currentTarget.style.backgroundColor = colors.darkBlue;
                    e.currentTarget.style.color = colors.yellow;
                  }}
                >
                  <svg
                    xmlns="http://www.w3.org/2000/svg"
                    viewBox="0 0 24 24"
                    fill="currentColor"
                    className="w-5 h-5"
                  >
                    <path fillRule="evenodd" d="M12 2.25c-5.385 0-9.75 4.365-9.75 9.75s4.365 9.75 9.75 9.75 9.75-4.365 9.75-9.75S17.385 2.25 12 2.25ZM12.75 6a.75.75 0 0 0-1.5 0v6c0 .414.336.75.75.75h4.5a.75.75 0 0 0 0-1.5h-3.75V6Z" clipRule="evenodd" />
                  </svg>
                  <span>{t('view_on_map') || 'View on Map'}</span>
                </a>
              </li>
            </ul>
          </div>

          {/* Social Media - تحديث لاستخدام البيانات */}
          <div className="mt-4 md:mt-0">
            <h4 className="text-lg font-bold mb-4" style={{ color: colors.yellow }}>
              {t('follow_us')}
            </h4>
            <div className={`flex gap-5 text-2xl ${isRTL ? 'justify-end' : 'justify-start'}`}>
              <a
                href={footerData.social.facebook}
                target="_blank"
                rel="noopener noreferrer"
                className="text-white dark:text-gray-200 hover:scale-110 transition-transform duration-200"
                onMouseEnter={(e) => (e.currentTarget.style.color = colors.yellow)}
                onMouseLeave={(e) => (e.currentTarget.style.color = 'white')}
                aria-label="Facebook"
              >
                <FaFacebook />
              </a>
              <a
                href={footerData.social.instagram}
                target="_blank"
                rel="noopener noreferrer"
                className="text-white dark:text-gray-200 hover:scale-110 transition-transform duration-200"
                onMouseEnter={(e) => (e.currentTarget.style.color = colors.yellow)}
                onMouseLeave={(e) => (e.currentTarget.style.color = 'white')}
                aria-label="Instagram"
              >
                <FaInstagram />
              </a>
              <a
                href={footerData.social.linkedin}
                target="_blank"
                rel="noopener noreferrer"
                className="text-white dark:text-gray-200 hover:scale-110 transition-transform duration-200"
                onMouseEnter={(e) => (e.currentTarget.style.color = colors.yellow)}
                onMouseLeave={(e) => (e.currentTarget.style.color = 'white')}
                aria-label="LinkedIn"
              >
                <FaLinkedin />
              </a>
              <a
                href={footerData.social.tiktok}
                target="_blank"
                rel="noopener noreferrer"
                className="text-white dark:text-gray-200 hover:scale-110 transition-transform duration-200"
                onMouseEnter={(e) => (e.currentTarget.style.color = colors.yellow)}
                onMouseLeave={(e) => (e.currentTarget.style.color = 'white')}
                aria-label="TikTok"
              >
                <FaTiktok />
              </a>
              <a
                href={footerData.social.whatsapp}
                target="_blank"
                rel="noopener noreferrer"
                className="text-white dark:text-gray-200 hover:scale-110 transition-transform duration-200"
                onMouseEnter={(e) => (e.currentTarget.style.color = colors.yellow)}
                onMouseLeave={(e) => (e.currentTarget.style.color = 'white')}
                aria-label="WhatsApp"
              >
                <FaWhatsapp />
              </a>
            </div>
          </div>
        </div>

        {/* Bottom Copyright */}
<div className="mt-12 border-t border-gray-700 dark:border-gray-700 text-center text-sm pt-6 space-y-2">
  <p className="text-gray-300 dark:text-gray-400"> 
    © {new Date().getFullYear()} One Stop Company. {t('all_rights_reserved')}
  </p>
  
  {/* إضافة Developed by */}
  <p className="text-gray-400 dark:text-gray-500 text-sm">
  Developed by:{' '}
  <a
    href="https://www.fb.com/anasamro90"
    target="_blank"
    rel="noopener noreferrer"
    className="font-medium text-yellow-300 hover:text-yellow-400 transition-colors duration-200"
  >
    Anas Amro
  </a>
</p>


        </div>
      </div>
    </footer>
  );
};

export default Footer;